// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"565":"21d00bf3","952":"5da3f59c"}[chunkId] + ".js";
};